import { createContext, useContext, type ReactNode } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

/** Contexto de layout da tela de sumário — mobile usa cards + ScreenMobile. */
const EhrRecordsLayoutContext = createContext(false);

/**
 * true só quando o prontuário foi aberto pela teleconsultoria.
 * Fora dessa página o valor fica false e as ações clínicas seguem iguais.
 */
const EhrRecordsCallOnlyContext = createContext(false);

export function EhrRecordsLayoutProvider({
  isMobileLayout,
  callOnly = false,
  children,
}: {
  isMobileLayout: boolean;
  /** Esconde iniciar atendimento, evolução e demais ações. Resta só a chamada. */
  callOnly?: boolean;
  children: ReactNode;
}) {
  return (
    <EhrRecordsCallOnlyContext.Provider value={callOnly}>
      <EhrRecordsLayoutContext.Provider value={isMobileLayout}>
        {children}
      </EhrRecordsLayoutContext.Provider>
    </EhrRecordsCallOnlyContext.Provider>
  );
}

export function useEhrRecordsCallOnly(): boolean {
  return useContext(EhrRecordsCallOnlyContext);
}

/** true quando a página EHRRecords está no layout mobile (ScreenMobile). */
export function useEhrRecordsMobileLayout(): boolean {
  return useContext(EhrRecordsLayoutContext);
}

/**
 * true quando a UI deve usar cards em vez de tabelas:
 * contexto EHR mobile OU viewport abaixo de md (ex.: ViewDocs, PatientDocs estreito).
 */
export function usePreferMobileCards(): boolean {
  const fromEhrContext = useEhrRecordsMobileLayout();
  const theme = useTheme();
  const fromBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  return fromEhrContext || fromBreakpoint;
}
